// Auto-generated from BMS_Data_Final_27032026.xlsx — do not edit manually
// Generated on: 2026-04-07T01:04:03.526Z
// Source sheets: Material Consumption (519), Inprocess Tests (126), Product Release Tests (70), Deviations (1), Change Controls (5)
export const messagesData = {
  "batches": [
    {
      "batchNumber": "DBSQC25001",
      "messages": [
        {
          "id": 1,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25001",
          "targetQuantity": "170 Kg",
          "actualQuantity": "170 Kg"
        },
        {
          "id": 2,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-25082",
          "targetQuantity": "4 Each",
          "actualQuantity": "4 Each"
        },
        {
          "id": 3,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-25083",
          "targetQuantity": "4 Each",
          "actualQuantity": "4 Each"
        },
        {
          "id": 4,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-25086",
          "targetQuantity": "5 Each",
          "actualQuantity": "5 Each"
        },
        {
          "id": 5,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR",
          "cmoMaterialCode": "PCNCT00040",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00040-25028",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 6,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR",
          "cmoMaterialCode": "PCNCT00040",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00040-25028",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 7,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE BARREL GREEN COLOUR (MODEL: NMB) (CAPACITY - 210 LTR)",
          "cmoMaterialCode": "PCNDR00058",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNDR00058-25043",
          "targetQuantity": "2 numbers",
          "actualQuantity": "2 numbers"
        },
        {
          "id": 8,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-25013",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 9,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-25013",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 10,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-25014",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 11,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-25020",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 12,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-25020",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 13,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-25021",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 14,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-02",
          "targetQuantity": "250 Lt.",
          "actualQuantity": "250 Lt."
        },
        {
          "id": 15,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-02",
          "targetQuantity": "1700 Lt.",
          "actualQuantity": "1700 Lt."
        },
        {
          "id": 16,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-02",
          "targetQuantity": "51 Lt.",
          "actualQuantity": "51 Lt."
        },
        {
          "id": 17,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-02",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 18,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-02",
          "targetQuantity": "510 Lt.",
          "actualQuantity": "0 Lt."
        },
        {
          "id": 19,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-06",
          "targetQuantity": "510 Lt.",
          "actualQuantity": "510 Lt."
        },
        {
          "id": 20,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-06",
          "targetQuantity": "850 Lt.",
          "actualQuantity": "850 Lt."
        },
        {
          "id": 21,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-06",
          "targetQuantity": "150 Lt.",
          "actualQuantity": "150 Lt."
        },
        {
          "id": 22,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25009-06",
          "targetQuantity": "850 Lt.",
          "actualQuantity": "850 Lt."
        },
        {
          "id": 23,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02121925",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 24,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02121925",
          "targetQuantity": "27 Lt.",
          "actualQuantity": "27 Lt."
        },
        {
          "id": 25,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02121725",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 26,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25011",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 27,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25011",
          "targetQuantity": "5 Lt.",
          "actualQuantity": "5 Lt."
        },
        {
          "id": 28,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 29,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 30,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 31,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 32,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 33,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "242.72727 Lt.",
          "actualQuantity": "242.72727 Lt."
        },
        {
          "id": 34,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "257.27272 Lt.",
          "actualQuantity": "257.27272 Lt."
        },
        {
          "id": 35,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 36,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 37,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02122525",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 38,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02122525",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 39,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02122525",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 40,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02122625",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 41,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02122825",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 42,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 43,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 44,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010226",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 45,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 46,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010526",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 47,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 48,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 49,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 50,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 51,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010626",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 52,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010626",
          "targetQuantity": "60 Lt.",
          "actualQuantity": "60 Lt."
        },
        {
          "id": 53,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010826",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 54,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 55,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 56,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 57,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 58,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 59,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 60,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010826",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 61,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010926",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 62,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02010826",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 63,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25012",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 64,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02012026",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 65,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030126",
          "targetQuantity": "250 Lt.",
          "actualQuantity": "250 Lt."
        },
        {
          "id": 66,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "58.82 Kg",
          "actualQuantity": "58.82 Kg"
        },
        {
          "id": 67,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "8.33 Kg",
          "actualQuantity": "0 Kg"
        },
        {
          "id": 68,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02022426",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 69,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "38.63636 Lt.",
          "actualQuantity": "38.63636 Lt."
        },
        {
          "id": 70,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 71,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 72,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 73,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "183.63636 Lt.",
          "actualQuantity": "183.63636 Lt."
        },
        {
          "id": 74,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "17.72728 Lt.",
          "actualQuantity": "17.72728 Lt."
        },
        {
          "id": 75,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 76,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 77,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030226",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 78,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030426",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 79,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031526",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 80,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031526",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 81,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031526",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 82,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031526",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 83,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 84,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "3 Lt.",
          "actualQuantity": "3 Lt."
        },
        {
          "id": 85,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 86,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031326",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 520,
          "timestamp": "20-DEC-2025 03:42:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "20-DEC-2025 03:42:50",
          "sampleID": "D/IM/25/12/0957",
          "sampleDescription": "DIP25121105",
          "specificationLimit": "Report the result",
          "resultValue": "0.0004",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 521,
          "timestamp": "20-DEC-2025 03:42:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "20-DEC-2025 03:42:50",
          "sampleID": "D/IM/25/12/0957",
          "sampleDescription": "DIP25121105",
          "specificationLimit": "Report the result",
          "resultValue": "0.744",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 522,
          "timestamp": "04-JAN-2026 07:30:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "04-JAN-2026 07:30:50",
          "sampleID": "D/IM/26/01/0190",
          "sampleDescription": "DIP26010222",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 523,
          "timestamp": "08-JAN-2026 08:25:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "08-JAN-2026 08:25:50",
          "sampleID": "D/IM/26/01/0337",
          "sampleDescription": "DIP26010484",
          "specificationLimit": "Report the result",
          "resultValue": "0.943",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 524,
          "timestamp": "08-JAN-2026 08:25:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "08-JAN-2026 08:25:50",
          "sampleID": "D/IM/26/01/0337",
          "sampleDescription": "DIP26010484",
          "specificationLimit": "Report the result",
          "resultValue": "0.037",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 525,
          "timestamp": "08-JAN-2026 08:25:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "08-JAN-2026 08:25:50",
          "sampleID": "D/IM/26/01/0337",
          "sampleDescription": "DIP26010484",
          "specificationLimit": "Report the result",
          "resultValue": "0.0017",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 526,
          "timestamp": "14-JAN-2026 10:58:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "14-JAN-2026 10:58:50",
          "sampleID": "D/IM/26/01/0765",
          "sampleDescription": "DIP26010843",
          "specificationLimit": "Report the result",
          "resultValue": "0.968",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/66",
          "uom": "%"
        },
        {
          "id": 527,
          "timestamp": "14-JAN-2026 10:58:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "14-JAN-2026 10:58:50",
          "sampleID": "D/IM/26/01/0765",
          "sampleDescription": "DIP26010843",
          "specificationLimit": "Report the result",
          "resultValue": "0.0071",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/66",
          "uom": "%"
        },
        {
          "id": 528,
          "timestamp": "14-JAN-2026 10:58:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "14-JAN-2026 10:58:50",
          "sampleID": "D/IM/26/01/0765",
          "sampleDescription": "DIP26010843",
          "specificationLimit": "Report the result",
          "resultValue": "0.0017",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/66",
          "uom": "%"
        },
        {
          "id": 529,
          "timestamp": "15-JAN-2026 16:15:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "15-JAN-2026 16:15:50",
          "sampleID": "D/IM/26/01/0836",
          "sampleDescription": "DIP26010925",
          "specificationLimit": "Report the result",
          "resultValue": "1.7 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 530,
          "timestamp": "16-JAN-2026 01:47:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "16-JAN-2026 01:47:49",
          "sampleID": "D/IM/26/01/0870",
          "sampleDescription": "DIP26010951",
          "specificationLimit": "Report the result",
          "resultValue": "0.45 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 532,
          "timestamp": "23-JAN-2026 13:16:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Hydrazine in Stage-C filtrate mL’s by GC-HS (ppm)",
          "dateOfSampling": "23-JAN-2026 13:16:49",
          "sampleID": "D/IM/26/01/1357",
          "sampleDescription": "DIP26011507",
          "specificationLimit": "Not more than 200",
          "resultValue": "2.5 ppm",
          "resultPassFail": "Pass",
          "operationNumber": "Cont of Hydrazine in St-C filtrte mL’s byGC-HS sample as er Annexure (BSQ-IP-03test 5)/17",
          "uom": "ppm"
        },
        {
          "id": 646,
          "timestamp": "17-JAN-2026 13:15:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "17-JAN-2026 13:15:50",
          "sampleID": "D/IM/26/01/0930",
          "sampleDescription": "DIMCBSQ260001",
          "specificationLimit": "Report the observation",
          "resultValue": "pale  brown color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 647,
          "timestamp": "17-JAN-2026 13:15:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "17-JAN-2026 13:15:50",
          "sampleID": "D/IM/26/01/0930",
          "sampleDescription": "DIMCBSQ260001",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 648,
          "timestamp": "17-JAN-2026 13:15:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "17-JAN-2026 13:15:50",
          "sampleID": "D/IM/26/01/0930",
          "sampleDescription": "DIMCBSQ260001",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.6",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 649,
          "timestamp": "17-JAN-2026 13:15:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "17-JAN-2026 13:15:50",
          "sampleID": "D/IM/26/01/0930",
          "sampleDescription": "DIMCBSQ260001",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.974",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 650,
          "timestamp": "17-JAN-2026 13:15:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "17-JAN-2026 13:15:50",
          "sampleID": "D/IM/26/01/0930",
          "sampleDescription": "DIMCBSQ260001",
          "specificationLimit": "Report the result",
          "resultValue": "93.8 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": "% w/w"
        },
        {
          "id": 651,
          "timestamp": "17-JAN-2026 13:15:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "17-JAN-2026 13:15:50",
          "sampleID": "D/IM/26/01/0930",
          "sampleDescription": "DIMCBSQ260001",
          "specificationLimit": "Report the result",
          "resultValue": "94.4 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": "% w/w"
        },
        {
          "id": 716,
          "timestamp": "23-DEC-2025 15:46:27",
          "messageType": "Deviations",
          "procedureNumber": "",
          "deviationTitle": "DR-D-BSQ-25-001",
          "dateOfDeviation": "23-DEC-2025 15:46:27",
          "assignedToRole": "",
          "assignedToUser": "",
          "requireSponsorReviewSME": "",
          "requireSponsorReviewQA": "",
          "investigationNumber": "",
          "deviationStatus": "Closed",
          "deviationCategory": " Process",
          "deviationType": "Major",
          "initialDescription": "Product: 4-(Aminomethyl)-6-bromophthalazin-1(2H)-one (MIR-006432) (BSQ stage-C) (In House code- BSQ Stage-C) #DBSQC25001 is under execution at Production Block-11 through BPR (MBPR-BSQC-001, Version no.:00). At Op. No.: 44, during the filtration in Agitated Nutsche Filter Dryer #DNFD25-1, material passing was observed in the filtered mother liquors (MLs). This was observed by Mr. Grandhe Sriram, Production Shift In-charge on date 21-Dec-2025.",
          "correctiveActions": "",
          "preventiveActions": "The filter cloth fixing checklist for Agitated Nutsche Filter Dryer (ANFD) (reference No. F-PR-113) shall be revised to incorporate the following checkpoints: a)\tVerification of the straightness of the fixing plates by placing the fixing plates on the ANFD bottom dish. b)\tA note point shall be incorporated as “If any abnormality is observed and rectification is performed during filter cloth fixing verification, all checkpoints shall be repeated by using a new checklist after the rectification”."
        }
      ]
    },
    {
      "batchNumber": "DBSQC26001",
      "messages": [
        {
          "id": 87,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "134.94 Kg",
          "actualQuantity": "134.94 Kg"
        },
        {
          "id": 88,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 89,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02012226",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 90,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02012226",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 91,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02012226",
          "targetQuantity": "61 Lt.",
          "actualQuantity": "61 Lt."
        },
        {
          "id": 92,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-01",
          "targetQuantity": "3900 Lt.",
          "actualQuantity": "3900 Lt."
        },
        {
          "id": 93,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-01",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 94,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-01",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 95,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-01",
          "targetQuantity": "117 Lt.",
          "actualQuantity": "117 Lt."
        },
        {
          "id": 96,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-02",
          "targetQuantity": "1170 Lt.",
          "actualQuantity": "1170 Lt."
        },
        {
          "id": 97,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-02",
          "targetQuantity": "1950 Lt.",
          "actualQuantity": "1950 Lt."
        },
        {
          "id": 98,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "60 Lt.",
          "actualQuantity": "60 Lt."
        },
        {
          "id": 99,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 100,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 101,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 102,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26001",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 103,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26004",
          "targetQuantity": "12 Each",
          "actualQuantity": "12 Each"
        },
        {
          "id": 104,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25001",
          "targetQuantity": "0.74 Kg",
          "actualQuantity": "0.74 Kg"
        },
        {
          "id": 105,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25002",
          "targetQuantity": "312.56 Kg",
          "actualQuantity": "312.56 Kg"
        },
        {
          "id": 106,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25003",
          "targetQuantity": "76.7 Kg",
          "actualQuantity": "76.7 Kg"
        },
        {
          "id": 531,
          "timestamp": "22-JAN-2026 04:48:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "22-JAN-2026 04:48:50",
          "sampleID": "D/IM/26/01/1266",
          "sampleDescription": "DIP26011409",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 533,
          "timestamp": "23-JAN-2026 14:09:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "23-JAN-2026 14:09:50",
          "sampleID": "D/IM/26/01/1361",
          "sampleDescription": "DIP26011511",
          "specificationLimit": "Report the result",
          "resultValue": "0.0006",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 534,
          "timestamp": "23-JAN-2026 14:09:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "23-JAN-2026 14:09:50",
          "sampleID": "D/IM/26/01/1361",
          "sampleDescription": "DIP26011511",
          "specificationLimit": "Report the result",
          "resultValue": "0.726",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 535,
          "timestamp": "02-FEB-2026 21:48:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "02-FEB-2026 21:48:50",
          "sampleID": "D/IM/26/02/0124",
          "sampleDescription": "DIP26020174",
          "specificationLimit": "Report the result",
          "resultValue": "0.891",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 536,
          "timestamp": "02-FEB-2026 21:48:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "02-FEB-2026 21:48:50",
          "sampleID": "D/IM/26/02/0124",
          "sampleDescription": "DIP26020174",
          "specificationLimit": "Report the result",
          "resultValue": "0.072",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 537,
          "timestamp": "02-FEB-2026 21:48:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "02-FEB-2026 21:48:50",
          "sampleID": "D/IM/26/02/0124",
          "sampleDescription": "DIP26020174",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 538,
          "timestamp": "08-FEB-2026 07:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "08-FEB-2026 07:29:50",
          "sampleID": "D/IM/26/02/0605",
          "sampleDescription": "DIP26020687",
          "specificationLimit": "Report the result",
          "resultValue": "0.965",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/66",
          "uom": "%"
        },
        {
          "id": 539,
          "timestamp": "08-FEB-2026 07:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "08-FEB-2026 07:29:50",
          "sampleID": "D/IM/26/02/0605",
          "sampleDescription": "DIP26020687",
          "specificationLimit": "Report the result",
          "resultValue": "0.006",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/66",
          "uom": "%"
        },
        {
          "id": 540,
          "timestamp": "08-FEB-2026 07:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "08-FEB-2026 07:29:50",
          "sampleID": "D/IM/26/02/0605",
          "sampleDescription": "DIP26020687",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/66",
          "uom": "%"
        },
        {
          "id": 541,
          "timestamp": "12-FEB-2026 15:30:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "12-FEB-2026 15:30:50",
          "sampleID": "D/IM/26/02/0990",
          "sampleDescription": "DIP26021107",
          "specificationLimit": "Report the result",
          "resultValue": "5.6 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 542,
          "timestamp": "13-FEB-2026 00:18:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "13-FEB-2026 00:18:50",
          "sampleID": "D/IM/26/02/1031",
          "sampleDescription": "DIP26021147",
          "specificationLimit": "Report the result",
          "resultValue": "5.5 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 543,
          "timestamp": "13-FEB-2026 06:42:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "13-FEB-2026 06:42:50",
          "sampleID": "D/IM/26/02/1051",
          "sampleDescription": "DIP26021171",
          "specificationLimit": "Report the result",
          "resultValue": "5.8 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 544,
          "timestamp": "13-FEB-2026 13:21:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "13-FEB-2026 13:21:50",
          "sampleID": "D/IM/26/02/1069",
          "sampleDescription": "DIP26021197",
          "specificationLimit": "Report the result",
          "resultValue": "5.6 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 545,
          "timestamp": "14-FEB-2026 01:50:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "14-FEB-2026 01:50:49",
          "sampleID": "D/IM/26/02/1115",
          "sampleDescription": "DIP26021243",
          "specificationLimit": "Report the result",
          "resultValue": "5.4 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 546,
          "timestamp": "14-FEB-2026 08:04:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "14-FEB-2026 08:04:49",
          "sampleID": "D/IM/26/02/1146",
          "sampleDescription": "DIP26021267",
          "specificationLimit": "Report the result",
          "resultValue": "5.0 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 547,
          "timestamp": "14-FEB-2026 15:11:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "14-FEB-2026 15:11:50",
          "sampleID": "D/IM/26/02/1181",
          "sampleDescription": "DIP26021293",
          "specificationLimit": "Report the result",
          "resultValue": "5.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 548,
          "timestamp": "15-FEB-2026 08:45:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "15-FEB-2026 08:45:50",
          "sampleID": "D/IM/26/02/1234",
          "sampleDescription": "DIP26021351",
          "specificationLimit": "Report the result",
          "resultValue": "2.2 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 652,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale brown color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 653,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 654,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "3.2 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 655,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.959",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 656,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "Report the result",
          "resultValue": "89.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": "% w/w"
        },
        {
          "id": 657,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "Report the result",
          "resultValue": "92.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": "% w/w"
        },
        {
          "id": 658,
          "timestamp": "16-FEB-2026 18:31:49",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Use test",
          "dateOfSampling": "16-FEB-2026 18:31:49",
          "sampleID": "D/IM/26/02/1354",
          "sampleDescription": "DIMCBSQ260002",
          "specificationLimit": "Report the result",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        }
      ]
    },
    {
      "batchNumber": "DBSQC26002",
      "messages": [
        {
          "id": 107,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25003",
          "targetQuantity": "234.99 Kg",
          "actualQuantity": "0 Kg"
        },
        {
          "id": 108,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25004",
          "targetQuantity": "155.01 Kg",
          "actualQuantity": "0 Kg"
        },
        {
          "id": 109,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "134.94 Kg",
          "actualQuantity": "0 Kg"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26003",
      "messages": [
        {
          "id": 110,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "34.6 Kg",
          "actualQuantity": "34.6 Kg"
        },
        {
          "id": 111,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "4.9 Kg",
          "actualQuantity": "0 Kg"
        },
        {
          "id": 112,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 113,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 114,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "21.81818 Lt.",
          "actualQuantity": "21.81818 Lt."
        },
        {
          "id": 115,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26001",
          "targetQuantity": "18.18181 Lt.",
          "actualQuantity": "18.18181 Lt."
        },
        {
          "id": 116,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 117,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02022226",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 118,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26002",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 119,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25003",
          "targetQuantity": "100 Kg",
          "actualQuantity": "100 Kg"
        },
        {
          "id": 120,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26011",
          "targetQuantity": "12 Each",
          "actualQuantity": "12 Each"
        },
        {
          "id": 121,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26002",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 122,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02021726",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 123,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02021726",
          "targetQuantity": "15.7 Lt.",
          "actualQuantity": "15.7 Lt."
        },
        {
          "id": 124,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02021726",
          "targetQuantity": "15.7 Lt.",
          "actualQuantity": "15.7 Lt."
        },
        {
          "id": 125,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 126,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 127,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "46 Lt.",
          "actualQuantity": "0 Lt."
        },
        {
          "id": 128,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "1000 Lt.",
          "actualQuantity": "1000 Lt."
        },
        {
          "id": 129,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 130,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "202 Lt.",
          "actualQuantity": "0 Lt."
        },
        {
          "id": 131,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "121 Lt.",
          "actualQuantity": "0 Lt."
        },
        {
          "id": 132,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 133,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 134,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "131 Lt.",
          "actualQuantity": "0 Lt."
        },
        {
          "id": 135,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02021626",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 549,
          "timestamp": "16-FEB-2026 03:24:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "16-FEB-2026 03:24:49",
          "sampleID": "D/IM/26/02/1315",
          "sampleDescription": "DIP26021440",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 552,
          "timestamp": "18-FEB-2026 11:20:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "18-FEB-2026 11:20:50",
          "sampleID": "D/IM/26/02/1485",
          "sampleDescription": "DIP26021654",
          "specificationLimit": "Report the result",
          "resultValue": "0.0006",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 553,
          "timestamp": "18-FEB-2026 11:20:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "18-FEB-2026 11:20:50",
          "sampleID": "D/IM/26/02/1485",
          "sampleDescription": "DIP26021654",
          "specificationLimit": "Report the result",
          "resultValue": "0.774",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 556,
          "timestamp": "20-FEB-2026 21:19:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "20-FEB-2026 21:19:50",
          "sampleID": "D/IM/26/02/1664",
          "sampleDescription": "DIP26021895",
          "specificationLimit": "Report the result",
          "resultValue": "0.973",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 557,
          "timestamp": "20-FEB-2026 21:19:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "20-FEB-2026 21:19:50",
          "sampleID": "D/IM/26/02/1664",
          "sampleDescription": "DIP26021895",
          "specificationLimit": "Report the result",
          "resultValue": "0.0091",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 558,
          "timestamp": "20-FEB-2026 21:19:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "20-FEB-2026 21:19:50",
          "sampleID": "D/IM/26/02/1664",
          "sampleDescription": "DIP26021895",
          "specificationLimit": "Report the result",
          "resultValue": "0.0011",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/58",
          "uom": "%"
        },
        {
          "id": 559,
          "timestamp": "22-FEB-2026 09:01:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "22-FEB-2026 09:01:49",
          "sampleID": "D/IM/26/02/1874",
          "sampleDescription": "DIP26022031",
          "specificationLimit": "Report the result",
          "resultValue": "2.4 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 561,
          "timestamp": "22-FEB-2026 15:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "22-FEB-2026 15:29:50",
          "sampleID": "D/IM/26/02/1898",
          "sampleDescription": "DIP26022064",
          "specificationLimit": "Report the result",
          "resultValue": "2.5 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 564,
          "timestamp": "22-FEB-2026 21:41:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "22-FEB-2026 21:41:50",
          "sampleID": "D/IM/26/02/1927",
          "sampleDescription": "DIP26022093",
          "specificationLimit": "Report the result",
          "resultValue": "5.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 565,
          "timestamp": "23-FEB-2026 04:04:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "23-FEB-2026 04:04:50",
          "sampleID": "D/IM/26/02/1954",
          "sampleDescription": "DIP26022120",
          "specificationLimit": "Report the result",
          "resultValue": "6.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 566,
          "timestamp": "23-FEB-2026 11:08:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "23-FEB-2026 11:08:49",
          "sampleID": "D/IM/26/02/1986",
          "sampleDescription": "DIP26022145",
          "specificationLimit": "Report the result",
          "resultValue": "5.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 567,
          "timestamp": "23-FEB-2026 17:57:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "23-FEB-2026 17:57:50",
          "sampleID": "D/IM/26/02/2006",
          "sampleDescription": "DIP26022169",
          "specificationLimit": "Report the result",
          "resultValue": "4.7 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 568,
          "timestamp": "24-FEB-2026 00:27:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "24-FEB-2026 00:27:49",
          "sampleID": "D/IM/26/02/2029",
          "sampleDescription": "DIP26022198",
          "specificationLimit": "Report the result",
          "resultValue": "4.4 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 571,
          "timestamp": "24-FEB-2026 08:35:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "24-FEB-2026 08:35:49",
          "sampleID": "D/IM/26/02/2053",
          "sampleDescription": "DIP26022232",
          "specificationLimit": "Report the result",
          "resultValue": "8.2 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 572,
          "timestamp": "24-FEB-2026 21:40:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "24-FEB-2026 21:40:50",
          "sampleID": "D/IM/26/02/2099",
          "sampleDescription": "DIP26022267",
          "specificationLimit": "Report the result",
          "resultValue": "4.9 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 576,
          "timestamp": "25-FEB-2026 13:15:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "25-FEB-2026 13:15:50",
          "sampleID": "D/IM/26/02/2168",
          "sampleDescription": "DIP26022347",
          "specificationLimit": "Report the result",
          "resultValue": "4.5 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/72",
          "uom": "% w/w"
        },
        {
          "id": 665,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 666,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 667,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "3.9 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 668,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.962",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        },
        {
          "id": 669,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "Report the result",
          "resultValue": "94.7 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": "% w/w"
        },
        {
          "id": 670,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "Report the result",
          "resultValue": "98.5 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": "% w/w"
        },
        {
          "id": 671,
          "timestamp": "01-MAR-2026 09:26:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Use test",
          "dateOfSampling": "01-MAR-2026 09:26:50",
          "sampleID": "D/IM/26/02/2497",
          "sampleDescription": "DIMCBSQ260004",
          "specificationLimit": "Report the result",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "complete analysis/75",
          "uom": ""
        }
      ]
    },
    {
      "batchNumber": "DBSQC26004",
      "messages": [
        {
          "id": 136,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS",
          "cmoMaterialCode": "PCNCT00084",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00084-26007",
          "targetQuantity": "8 numbers",
          "actualQuantity": "8 numbers"
        },
        {
          "id": 137,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26002",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 138,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 139,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS",
          "cmoMaterialCode": "PCNCT00084",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00084-26006",
          "targetQuantity": "6 numbers",
          "actualQuantity": "6 numbers"
        },
        {
          "id": 140,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS",
          "cmoMaterialCode": "PCNCT00084",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00084-26007",
          "targetQuantity": "6 numbers",
          "actualQuantity": "6 numbers"
        },
        {
          "id": 141,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26012",
          "targetQuantity": "6 Each",
          "actualQuantity": "6 Each"
        },
        {
          "id": 142,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26012",
          "targetQuantity": "6 Each",
          "actualQuantity": "6 Each"
        },
        {
          "id": 143,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26013",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 144,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25003",
          "targetQuantity": "134.99 Kg",
          "actualQuantity": "134.99 Kg"
        },
        {
          "id": 145,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25004",
          "targetQuantity": "65.01 Kg",
          "actualQuantity": "65.01 Kg"
        },
        {
          "id": 146,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26002",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 147,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26002",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 148,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-10",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 149,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 150,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-10",
          "targetQuantity": "700 Lt.",
          "actualQuantity": "700 Lt."
        },
        {
          "id": 151,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-10",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 152,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-10",
          "targetQuantity": "600 Lt.",
          "actualQuantity": "600 Lt."
        },
        {
          "id": 153,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-09",
          "targetQuantity": "60 Lt.",
          "actualQuantity": "60 Lt."
        },
        {
          "id": 154,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-09",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 155,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-09",
          "targetQuantity": "600 Lt.",
          "actualQuantity": "600 Lt."
        },
        {
          "id": 156,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-09",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 157,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-09",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 158,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "150 Lt.",
          "actualQuantity": "150 Lt."
        },
        {
          "id": 159,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-08",
          "targetQuantity": "942.73624 Lt.",
          "actualQuantity": "942.73624 Lt."
        },
        {
          "id": 160,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-09",
          "targetQuantity": "1057.26376 Lt.",
          "actualQuantity": "1057.26376 Lt."
        },
        {
          "id": 161,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01021826",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 162,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01021826",
          "targetQuantity": "31 Lt.",
          "actualQuantity": "31 Lt."
        },
        {
          "id": 163,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01021726",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 164,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS01021726",
          "targetQuantity": "1500 Lt.",
          "actualQuantity": "1500 Lt."
        },
        {
          "id": 165,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "69.2 Kg",
          "actualQuantity": "69.2 Kg"
        },
        {
          "id": 166,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01022126",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 167,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01022126",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 168,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01022226",
          "targetQuantity": "25 Lt.",
          "actualQuantity": "25 Lt."
        },
        {
          "id": 169,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26001",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 170,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26001",
          "targetQuantity": "19 Kg",
          "actualQuantity": "19 Kg"
        },
        {
          "id": 171,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26001",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 172,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 173,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 174,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 175,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 176,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030126",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 177,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1]",
          "cmoMaterialCode": "RSLCG00038",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00038-26001-13",
          "targetQuantity": "15.8 Kg",
          "actualQuantity": "15.8 Kg"
        },
        {
          "id": 178,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 179,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032026",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 180,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1]",
          "cmoMaterialCode": "RSLCG00038",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00038-26001-23",
          "targetQuantity": "15.8 Kg",
          "actualQuantity": "15.8 Kg"
        },
        {
          "id": 181,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01031626",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 182,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1]",
          "cmoMaterialCode": "RSLCG00038",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00038-26001-21",
          "targetQuantity": "39.5 Kg",
          "actualQuantity": "39.5 Kg"
        },
        {
          "id": 183,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032326",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 184,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1]",
          "cmoMaterialCode": "RSLCG00038",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00038-26001-25",
          "targetQuantity": "15.8 Kg",
          "actualQuantity": "15.8 Kg"
        },
        {
          "id": 185,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030426",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 186,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1]",
          "cmoMaterialCode": "RSLCG00038",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00038-26001-15",
          "targetQuantity": "15.8 Kg",
          "actualQuantity": "15.8 Kg"
        },
        {
          "id": 187,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01031326",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 188,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1]",
          "cmoMaterialCode": "RSLCG00038",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00038-26001-20",
          "targetQuantity": "15.8 Kg",
          "actualQuantity": "15.8 Kg"
        },
        {
          "id": 550,
          "timestamp": "17-FEB-2026 09:54:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "17-FEB-2026 09:54:50",
          "sampleID": "D/IM/26/02/1415",
          "sampleDescription": "DIP26021545",
          "specificationLimit": "Report the result",
          "resultValue": "0.04 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 551,
          "timestamp": "17-FEB-2026 18:54:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "17-FEB-2026 18:54:50",
          "sampleID": "D/IM/26/02/1459",
          "sampleDescription": "DIP26021590",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 554,
          "timestamp": "19-FEB-2026 14:04:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "19-FEB-2026 14:04:49",
          "sampleID": "D/IM/26/02/1568",
          "sampleDescription": "DIP26021774",
          "specificationLimit": "Report the result",
          "resultValue": "0.0001",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 555,
          "timestamp": "19-FEB-2026 14:04:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "19-FEB-2026 14:04:49",
          "sampleID": "D/IM/26/02/1568",
          "sampleDescription": "DIP26021774",
          "specificationLimit": "Report the result",
          "resultValue": "0.691",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 562,
          "timestamp": "22-FEB-2026 17:04:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "22-FEB-2026 17:04:49",
          "sampleID": "D/IM/26/02/1901",
          "sampleDescription": "DIP26022069",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 563,
          "timestamp": "22-FEB-2026 17:06:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "22-FEB-2026 17:06:50",
          "sampleID": "D/IM/26/02/1902",
          "sampleDescription": "DIP26022070",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 573,
          "timestamp": "25-FEB-2026 04:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "25-FEB-2026 04:29:50",
          "sampleID": "D/IM/26/02/1989",
          "sampleDescription": "DIP26022305",
          "specificationLimit": "Report the result",
          "resultValue": "0.986",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 574,
          "timestamp": "25-FEB-2026 04:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "25-FEB-2026 04:29:50",
          "sampleID": "D/IM/26/02/1989",
          "sampleDescription": "DIP26022305",
          "specificationLimit": "Report the result",
          "resultValue": "0.001",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 575,
          "timestamp": "25-FEB-2026 04:29:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "25-FEB-2026 04:29:50",
          "sampleID": "D/IM/26/02/1989",
          "sampleDescription": "DIP26022305",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 580,
          "timestamp": "27-FEB-2026 02:51:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "27-FEB-2026 02:51:50",
          "sampleID": "D/IM/26/02/2337",
          "sampleDescription": "DIP26022511",
          "specificationLimit": "Report the result",
          "resultValue": "1.9 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 581,
          "timestamp": "27-FEB-2026 11:47:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "27-FEB-2026 11:47:50",
          "sampleID": "D/IM/26/02/2368",
          "sampleDescription": "DIP26022547",
          "specificationLimit": "Report the result",
          "resultValue": "0.87 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 659,
          "timestamp": "28-FEB-2026 11:44:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "28-FEB-2026 11:44:50",
          "sampleID": "D/IM/26/02/2455",
          "sampleDescription": "DIMCBSQ260003",
          "specificationLimit": "Report the observation",
          "resultValue": "pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 660,
          "timestamp": "28-FEB-2026 11:44:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "28-FEB-2026 11:44:50",
          "sampleID": "D/IM/26/02/2455",
          "sampleDescription": "DIMCBSQ260003",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 661,
          "timestamp": "28-FEB-2026 11:44:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "28-FEB-2026 11:44:50",
          "sampleID": "D/IM/26/02/2455",
          "sampleDescription": "DIMCBSQ260003",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.27 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 662,
          "timestamp": "28-FEB-2026 11:44:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "28-FEB-2026 11:44:50",
          "sampleID": "D/IM/26/02/2455",
          "sampleDescription": "DIMCBSQ260003",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.98",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 663,
          "timestamp": "28-FEB-2026 11:44:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "28-FEB-2026 11:44:50",
          "sampleID": "D/IM/26/02/2455",
          "sampleDescription": "DIMCBSQ260003",
          "specificationLimit": "Report the result",
          "resultValue": "94.6 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 664,
          "timestamp": "28-FEB-2026 11:44:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "28-FEB-2026 11:44:50",
          "sampleID": "D/IM/26/02/2455",
          "sampleDescription": "DIMCBSQ260003",
          "specificationLimit": "Report the result",
          "resultValue": "94.9 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26005",
      "messages": [
        {
          "id": 189,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 190,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "5 Lt.",
          "actualQuantity": "5 Lt."
        },
        {
          "id": 191,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 192,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 193,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "34.6 Kg",
          "actualQuantity": "34.6 Kg"
        },
        {
          "id": 194,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 195,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-07",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 196,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 197,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-07",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 198,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-07",
          "targetQuantity": "1000 Lt.",
          "actualQuantity": "1000 Lt."
        },
        {
          "id": 199,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-07",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 200,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02022326",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 201,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02022326",
          "targetQuantity": "15.7 Lt.",
          "actualQuantity": "15.7 Lt."
        },
        {
          "id": 202,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02022226",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 203,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25004",
          "targetQuantity": "15.1 Kg",
          "actualQuantity": "15.1 Kg"
        },
        {
          "id": 204,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25004",
          "targetQuantity": "84.9 Kg",
          "actualQuantity": "84.9 Kg"
        },
        {
          "id": 205,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26013",
          "targetQuantity": "5 Each",
          "actualQuantity": "5 Each"
        },
        {
          "id": 206,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26002",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 207,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26003",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 560,
          "timestamp": "22-FEB-2026 08:55:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "22-FEB-2026 08:55:50",
          "sampleID": "D/IM/26/02/1875",
          "sampleDescription": "DIP26022032",
          "specificationLimit": "Report the result",
          "resultValue": "0.07 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 569,
          "timestamp": "24-FEB-2026 06:00:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "24-FEB-2026 06:00:50",
          "sampleID": "D/IM/26/02/1987",
          "sampleDescription": "DIP26022223",
          "specificationLimit": "Report the result",
          "resultValue": "0.0004",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 570,
          "timestamp": "24-FEB-2026 06:00:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "24-FEB-2026 06:00:50",
          "sampleID": "D/IM/26/02/1987",
          "sampleDescription": "DIP26022223",
          "specificationLimit": "Report the result",
          "resultValue": "0.68",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 586,
          "timestamp": "01-MAR-2026 01:40:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "01-MAR-2026 01:40:50",
          "sampleID": "D/IM/26/02/2466",
          "sampleDescription": "DIP26030005",
          "specificationLimit": "Report the result",
          "resultValue": "0.971",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/106",
          "uom": "%"
        },
        {
          "id": 587,
          "timestamp": "01-MAR-2026 01:40:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "01-MAR-2026 01:40:50",
          "sampleID": "D/IM/26/02/2466",
          "sampleDescription": "DIP26030005",
          "specificationLimit": "Report the result",
          "resultValue": "0.0033",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/106",
          "uom": "%"
        },
        {
          "id": 588,
          "timestamp": "01-MAR-2026 01:40:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "01-MAR-2026 01:40:50",
          "sampleID": "D/IM/26/02/2466",
          "sampleDescription": "DIP26030005",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/106",
          "uom": "%"
        },
        {
          "id": 590,
          "timestamp": "02-MAR-2026 05:17:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "02-MAR-2026 05:17:50",
          "sampleID": "D/IM/26/03/0158",
          "sampleDescription": "DIP26030148",
          "specificationLimit": "Report the result",
          "resultValue": "1.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/120",
          "uom": "% w/w"
        },
        {
          "id": 672,
          "timestamp": "03-MAR-2026 07:03:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "03-MAR-2026 07:03:50",
          "sampleID": "D/IM/26/03/0240",
          "sampleDescription": "DIMCBSQ260005",
          "specificationLimit": "Report the observation",
          "resultValue": "pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 673,
          "timestamp": "03-MAR-2026 07:03:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "03-MAR-2026 07:03:50",
          "sampleID": "D/IM/26/03/0240",
          "sampleDescription": "DIMCBSQ260005",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 674,
          "timestamp": "03-MAR-2026 07:03:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "03-MAR-2026 07:03:50",
          "sampleID": "D/IM/26/03/0240",
          "sampleDescription": "DIMCBSQ260005",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "1.0 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 675,
          "timestamp": "03-MAR-2026 07:03:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "03-MAR-2026 07:03:50",
          "sampleID": "D/IM/26/03/0240",
          "sampleDescription": "DIMCBSQ260005",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.978",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 676,
          "timestamp": "03-MAR-2026 07:03:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "03-MAR-2026 07:03:50",
          "sampleID": "D/IM/26/03/0240",
          "sampleDescription": "DIMCBSQ260005",
          "specificationLimit": "Report the result",
          "resultValue": "93.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 677,
          "timestamp": "03-MAR-2026 07:03:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "03-MAR-2026 07:03:50",
          "sampleID": "D/IM/26/03/0240",
          "sampleDescription": "DIMCBSQ260005",
          "specificationLimit": "Report the result",
          "resultValue": "94.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26006",
      "messages": [
        {
          "id": 208,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 209,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26002",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 210,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS",
          "cmoMaterialCode": "PCNCT00084",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00084-26008",
          "targetQuantity": "2 numbers",
          "actualQuantity": "2 numbers"
        },
        {
          "id": 211,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS",
          "cmoMaterialCode": "PCNCT00084",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00084-26009",
          "targetQuantity": "6 numbers",
          "actualQuantity": "6 numbers"
        },
        {
          "id": 212,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26014",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 213,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26015",
          "targetQuantity": "6 Each",
          "actualQuantity": "6 Each"
        },
        {
          "id": 214,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25004",
          "targetQuantity": "139.91 Kg",
          "actualQuantity": "139.91 Kg"
        },
        {
          "id": 215,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25005",
          "targetQuantity": "60.09 Kg",
          "actualQuantity": "60.09 Kg"
        },
        {
          "id": 216,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS01022626",
          "targetQuantity": "1500 Lt.",
          "actualQuantity": "1500 Lt."
        },
        {
          "id": 217,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 218,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "600 Lt.",
          "actualQuantity": "600 Lt."
        },
        {
          "id": 219,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "1200 Lt.",
          "actualQuantity": "1200 Lt."
        },
        {
          "id": 220,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 221,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "950 Lt.",
          "actualQuantity": "950 Lt."
        },
        {
          "id": 222,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 223,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 224,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "600 Lt.",
          "actualQuantity": "600 Lt."
        },
        {
          "id": 225,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 226,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 227,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 228,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "10.26376 Lt.",
          "actualQuantity": "10.26376 Lt."
        },
        {
          "id": 229,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-10",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 230,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-10",
          "targetQuantity": "49.73623 Lt.",
          "actualQuantity": "49.73623 Lt."
        },
        {
          "id": 231,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01022626",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 232,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01022626",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 233,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01022626",
          "targetQuantity": "31 Lt.",
          "actualQuantity": "31 Lt."
        },
        {
          "id": 234,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 235,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "69.2 Kg",
          "actualQuantity": "69.2 Kg"
        },
        {
          "id": 236,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030226",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 237,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "250 Lt.",
          "actualQuantity": "250 Lt."
        },
        {
          "id": 238,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 239,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 240,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 241,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030226",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 242,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26001",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 243,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 244,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 245,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 246,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 577,
          "timestamp": "26-FEB-2026 02:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "26-FEB-2026 02:19:49",
          "sampleID": "D/IM/26/02/2232",
          "sampleDescription": "DIP26022409",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 578,
          "timestamp": "26-FEB-2026 02:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "26-FEB-2026 02:19:49",
          "sampleID": "D/IM/26/02/2233",
          "sampleDescription": "DIP26022410",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 579,
          "timestamp": "26-FEB-2026 19:36:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "26-FEB-2026 19:36:50",
          "sampleID": "D/IM/26/02/2298",
          "sampleDescription": "DIP26022473",
          "specificationLimit": "Report the result",
          "resultValue": "0.09 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 582,
          "timestamp": "27-FEB-2026 15:37:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "27-FEB-2026 15:37:50",
          "sampleID": "D/IM/26/02/2333",
          "sampleDescription": "DIP26022564",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 583,
          "timestamp": "27-FEB-2026 15:37:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "27-FEB-2026 15:37:50",
          "sampleID": "D/IM/26/02/2333",
          "sampleDescription": "DIP26022564",
          "specificationLimit": "Report the result",
          "resultValue": "0.698",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 595,
          "timestamp": "04-MAR-2026 02:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "04-MAR-2026 02:19:49",
          "sampleID": "D/IM/26/03/0364",
          "sampleDescription": "DIP26030346",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 599,
          "timestamp": "06-MAR-2026 01:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "06-MAR-2026 01:19:49",
          "sampleID": "D/IM/26/03/0487",
          "sampleDescription": "DIP26030543",
          "specificationLimit": "Report the result",
          "resultValue": "0.972",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 600,
          "timestamp": "06-MAR-2026 01:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "06-MAR-2026 01:19:49",
          "sampleID": "D/IM/26/03/0487",
          "sampleDescription": "DIP26030543",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 601,
          "timestamp": "06-MAR-2026 01:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "06-MAR-2026 01:19:49",
          "sampleID": "D/IM/26/03/0487",
          "sampleDescription": "DIP26030543",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 605,
          "timestamp": "07-MAR-2026 17:27:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "07-MAR-2026 17:27:50",
          "sampleID": "D/IM/26/03/0681",
          "sampleDescription": "DIP26030650",
          "specificationLimit": "Report the result",
          "resultValue": "0.70 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 684,
          "timestamp": "09-MAR-2026 05:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "09-MAR-2026 05:45:50",
          "sampleID": "D/IM/26/03/0790",
          "sampleDescription": "DIMCBSQ260007",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 685,
          "timestamp": "09-MAR-2026 05:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "09-MAR-2026 05:45:50",
          "sampleID": "D/IM/26/03/0790",
          "sampleDescription": "DIMCBSQ260007",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 686,
          "timestamp": "09-MAR-2026 05:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "09-MAR-2026 05:45:50",
          "sampleID": "D/IM/26/03/0790",
          "sampleDescription": "DIMCBSQ260007",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.66 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 687,
          "timestamp": "09-MAR-2026 05:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "09-MAR-2026 05:45:50",
          "sampleID": "D/IM/26/03/0790",
          "sampleDescription": "DIMCBSQ260007",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.965",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 688,
          "timestamp": "09-MAR-2026 05:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "09-MAR-2026 05:45:50",
          "sampleID": "D/IM/26/03/0790",
          "sampleDescription": "DIMCBSQ260007",
          "specificationLimit": "Report the result",
          "resultValue": "91.0 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 689,
          "timestamp": "09-MAR-2026 05:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "09-MAR-2026 05:45:50",
          "sampleID": "D/IM/26/03/0790",
          "sampleDescription": "DIMCBSQ260007",
          "specificationLimit": "Report the result",
          "resultValue": "91.6 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26007",
      "messages": [
        {
          "id": 247,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26005",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 248,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26005",
          "targetQuantity": "19 Kg",
          "actualQuantity": "19 Kg"
        },
        {
          "id": 249,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26004",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 250,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030426",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 251,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030426",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 252,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030526",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 253,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 254,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "5 Lt.",
          "actualQuantity": "5 Lt."
        },
        {
          "id": 255,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 256,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 257,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 258,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 259,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 260,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 261,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031226",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 262,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030826",
          "targetQuantity": "240 Lt.",
          "actualQuantity": "240 Lt."
        },
        {
          "id": 263,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TOLUENE (THIOPHENE FREE) (COM) [ 108-88-3 ]",
          "cmoMaterialCode": "RSLCG00163",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00163-ST26006",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 264,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030726",
          "targetQuantity": "350 Lt.",
          "actualQuantity": "350 Lt."
        },
        {
          "id": 265,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030726",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 266,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030726",
          "targetQuantity": "600 Lt.",
          "actualQuantity": "600 Lt."
        },
        {
          "id": 267,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031026",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 268,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02030826",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 269,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "80 Lt.",
          "actualQuantity": "80 Lt."
        },
        {
          "id": 270,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "80 Lt.",
          "actualQuantity": "80 Lt."
        },
        {
          "id": 271,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 272,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 273,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "400 Lt.",
          "actualQuantity": "400 Lt."
        },
        {
          "id": 274,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 275,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "5 Lt.",
          "actualQuantity": "5 Lt."
        },
        {
          "id": 276,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TOLUENE (THIOPHENE FREE) (COM) [ 108-88-3 ]",
          "cmoMaterialCode": "RSLCG00163",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00163-ST26008",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 277,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "Process Water",
          "cmoMaterialCode": "PR",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPWS02031126",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 278,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TOLUENE (THIOPHENE FREE) (COM) [ 108-88-3 ]",
          "cmoMaterialCode": "RSLCG00163",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00163-ST26006",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 279,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TOLUENE (THIOPHENE FREE) (COM) [ 108-88-3 ]",
          "cmoMaterialCode": "RSLCG00163",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00163-ST26007",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 280,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 281,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26003",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 282,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030126",
          "targetQuantity": "16 Lt.",
          "actualQuantity": "16 Lt."
        },
        {
          "id": 283,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030126",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 284,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02022826",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 285,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 286,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "1000 Lt.",
          "actualQuantity": "1000 Lt."
        },
        {
          "id": 287,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 288,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 289,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 290,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 291,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "34.6 Kg",
          "actualQuantity": "34.6 Kg"
        },
        {
          "id": 292,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25005",
          "targetQuantity": "100 Kg",
          "actualQuantity": "100 Kg"
        },
        {
          "id": 293,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26015",
          "targetQuantity": "4 Each",
          "actualQuantity": "4 Each"
        },
        {
          "id": 294,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26002",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 585,
          "timestamp": "28-FEB-2026 21:13:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "28-FEB-2026 21:13:50",
          "sampleID": "D/IM/26/02/2523",
          "sampleDescription": "DIP26022700",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 593,
          "timestamp": "02-MAR-2026 20:08:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "02-MAR-2026 20:08:49",
          "sampleID": "D/IM/26/03/0176",
          "sampleDescription": "DIP26030230",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 594,
          "timestamp": "02-MAR-2026 20:08:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "02-MAR-2026 20:08:49",
          "sampleID": "D/IM/26/03/0176",
          "sampleDescription": "DIP26030230",
          "specificationLimit": "Report the result",
          "resultValue": "0.747",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 596,
          "timestamp": "05-MAR-2026 22:01:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "05-MAR-2026 22:01:50",
          "sampleID": "D/IM/26/03/0413",
          "sampleDescription": "DIP26030531",
          "specificationLimit": "Report the result",
          "resultValue": "0.963",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/106",
          "uom": "%"
        },
        {
          "id": 597,
          "timestamp": "05-MAR-2026 22:01:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "05-MAR-2026 22:01:50",
          "sampleID": "D/IM/26/03/0413",
          "sampleDescription": "DIP26030531",
          "specificationLimit": "Report the result",
          "resultValue": "0.0019",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/106",
          "uom": "%"
        },
        {
          "id": 598,
          "timestamp": "05-MAR-2026 22:01:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "05-MAR-2026 22:01:50",
          "sampleID": "D/IM/26/03/0413",
          "sampleDescription": "DIP26030531",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/106",
          "uom": "%"
        },
        {
          "id": 604,
          "timestamp": "07-MAR-2026 10:58:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "07-MAR-2026 10:58:50",
          "sampleID": "D/IM/26/03/0656",
          "sampleDescription": "DIP26030636",
          "specificationLimit": "Report the result",
          "resultValue": "0.96 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/120",
          "uom": "% w/w"
        },
        {
          "id": 678,
          "timestamp": "08-MAR-2026 10:33:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "08-MAR-2026 10:33:50",
          "sampleID": "D/IM/26/03/0726",
          "sampleDescription": "DIMCBSQ260006",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 679,
          "timestamp": "08-MAR-2026 10:33:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "08-MAR-2026 10:33:50",
          "sampleID": "D/IM/26/03/0726",
          "sampleDescription": "DIMCBSQ260006",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 680,
          "timestamp": "08-MAR-2026 10:33:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "08-MAR-2026 10:33:50",
          "sampleID": "D/IM/26/03/0726",
          "sampleDescription": "DIMCBSQ260006",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.90 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 681,
          "timestamp": "08-MAR-2026 10:33:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "08-MAR-2026 10:33:50",
          "sampleID": "D/IM/26/03/0726",
          "sampleDescription": "DIMCBSQ260006",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "96.8",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 682,
          "timestamp": "08-MAR-2026 10:33:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "08-MAR-2026 10:33:50",
          "sampleID": "D/IM/26/03/0726",
          "sampleDescription": "DIMCBSQ260006",
          "specificationLimit": "Report the result",
          "resultValue": "90.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 683,
          "timestamp": "08-MAR-2026 10:33:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "08-MAR-2026 10:33:50",
          "sampleID": "D/IM/26/03/0726",
          "sampleDescription": "DIMCBSQ260006",
          "specificationLimit": "Report the result",
          "resultValue": "91.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26008",
      "messages": [
        {
          "id": 295,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26003",
          "targetQuantity": "4 Kg",
          "actualQuantity": "4 Kg"
        },
        {
          "id": 296,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR",
          "cmoMaterialCode": "PCNCT00040",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00040-26005",
          "targetQuantity": "4 Each",
          "actualQuantity": "4 Each"
        },
        {
          "id": 297,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26017",
          "targetQuantity": "10 Each",
          "actualQuantity": "10 Each"
        },
        {
          "id": 298,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25005",
          "targetQuantity": "150.945 Kg",
          "actualQuantity": "150.945 Kg"
        },
        {
          "id": 299,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25006",
          "targetQuantity": "209.055 Kg",
          "actualQuantity": "209.055 Kg"
        },
        {
          "id": 300,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26015",
          "targetQuantity": "20 Each",
          "actualQuantity": "20 Each"
        },
        {
          "id": 301,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26016",
          "targetQuantity": "20 Each",
          "actualQuantity": "20 Each"
        },
        {
          "id": 302,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "124.56 Kg",
          "actualQuantity": "124.56 Kg"
        },
        {
          "id": 303,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26003",
          "targetQuantity": "10 Kg",
          "actualQuantity": "10 Kg"
        },
        {
          "id": 304,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "10 Kg",
          "actualQuantity": "10 Kg"
        },
        {
          "id": 305,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "4 Kg",
          "actualQuantity": "4 Kg"
        },
        {
          "id": 306,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "17.64 Kg",
          "actualQuantity": "0 Kg"
        },
        {
          "id": 307,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "270 Lt.",
          "actualQuantity": "270 Lt."
        },
        {
          "id": 308,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "1800 Lt.",
          "actualQuantity": "1800 Lt."
        },
        {
          "id": 309,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "194.13941 Lt.",
          "actualQuantity": "194.13941 Lt."
        },
        {
          "id": 310,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "108 Lt.",
          "actualQuantity": "108 Lt."
        },
        {
          "id": 311,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 312,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 313,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "270 Lt.",
          "actualQuantity": "270 Lt."
        },
        {
          "id": 314,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "270 Lt.",
          "actualQuantity": "270 Lt."
        },
        {
          "id": 315,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "270 Lt.",
          "actualQuantity": "270 Lt."
        },
        {
          "id": 316,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-13",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 317,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "2163 Lt.",
          "actualQuantity": "2163 Lt."
        },
        {
          "id": 318,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "68.69328 Lt.",
          "actualQuantity": "68.69328 Lt."
        },
        {
          "id": 319,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "200.31812 Lt.",
          "actualQuantity": "200.31812 Lt."
        },
        {
          "id": 320,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 321,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "810.98859 Lt.",
          "actualQuantity": "810.98859 Lt."
        },
        {
          "id": 322,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "250 Lt.",
          "actualQuantity": "250 Lt."
        },
        {
          "id": 323,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 324,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-11",
          "targetQuantity": "598.86058 Lt.",
          "actualQuantity": "598.86058 Lt."
        },
        {
          "id": 325,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-12",
          "targetQuantity": "644 Lt.",
          "actualQuantity": "644 Lt."
        },
        {
          "id": 326,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030126",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 327,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030126",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 328,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030126",
          "targetQuantity": "57 Lt.",
          "actualQuantity": "57 Lt."
        },
        {
          "id": 329,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030226",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 330,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030226",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 331,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030226",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 332,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26003",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 333,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26003",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 334,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26003",
          "targetQuantity": "19 Kg",
          "actualQuantity": "19 Kg"
        },
        {
          "id": 335,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 336,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02030626",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 337,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 338,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 339,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 340,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 341,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 584,
          "timestamp": "28-FEB-2026 16:58:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "28-FEB-2026 16:58:50",
          "sampleID": "D/IM/26/02/2493",
          "sampleDescription": "DIP26022673",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 589,
          "timestamp": "01-MAR-2026 13:32:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "01-MAR-2026 13:32:50",
          "sampleID": "D/IM/26/03/0081",
          "sampleDescription": "DIP26030075",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 591,
          "timestamp": "02-MAR-2026 10:39:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "02-MAR-2026 10:39:50",
          "sampleID": "D/IM/26/03/0083",
          "sampleDescription": "DIP26030177",
          "specificationLimit": "Report the result",
          "resultValue": "0.0007",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 592,
          "timestamp": "02-MAR-2026 10:39:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "02-MAR-2026 10:39:50",
          "sampleID": "D/IM/26/03/0083",
          "sampleDescription": "DIP26030177",
          "specificationLimit": "Report the result",
          "resultValue": "0.461",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 606,
          "timestamp": "08-MAR-2026 00:54:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "08-MAR-2026 00:54:50",
          "sampleID": "D/IM/26/03/0706",
          "sampleDescription": "DIP26030675",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 607,
          "timestamp": "08-MAR-2026 01:11:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "08-MAR-2026 01:11:50",
          "sampleID": "D/IM/26/03/0707",
          "sampleDescription": "DIP26030676",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 611,
          "timestamp": "09-MAR-2026 03:59:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "09-MAR-2026 03:59:50",
          "sampleID": "D/IM/26/03/0703",
          "sampleDescription": "DIP26030791",
          "specificationLimit": "Report the result",
          "resultValue": "0.974",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 612,
          "timestamp": "09-MAR-2026 03:59:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "09-MAR-2026 03:59:50",
          "sampleID": "D/IM/26/03/0703",
          "sampleDescription": "DIP26030791",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 613,
          "timestamp": "09-MAR-2026 03:59:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "09-MAR-2026 03:59:50",
          "sampleID": "D/IM/26/03/0703",
          "sampleDescription": "DIP26030791",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 615,
          "timestamp": "11-MAR-2026 05:49:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "11-MAR-2026 05:49:49",
          "sampleID": "D/IM/26/03/1003",
          "sampleDescription": "DIP26030963",
          "specificationLimit": "Report the result",
          "resultValue": "0.58 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 639,
          "timestamp": "22-MAR-2026 09:38:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Hydrazine in Stage-C filtrate mL’s by GC-HS (ppm)",
          "dateOfSampling": "22-MAR-2026 09:38:49",
          "sampleID": "D/IM/26/03/1964",
          "sampleDescription": "DIP26031940",
          "specificationLimit": "Not more than 200",
          "resultValue": "2.4 ppm",
          "resultPassFail": "Pass",
          "operationNumber": "Cont of Hydrazine in St-C filtrte mL’s byGC-HS sample as er Annexure (BSQ-IP-03test 5)/17",
          "uom": "ppm"
        },
        {
          "id": 690,
          "timestamp": "13-MAR-2026 12:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "13-MAR-2026 12:45:50",
          "sampleID": "D/IM/26/03/1149",
          "sampleDescription": "DIMCBSQ260008",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 691,
          "timestamp": "13-MAR-2026 12:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "13-MAR-2026 12:45:50",
          "sampleID": "D/IM/26/03/1149",
          "sampleDescription": "DIMCBSQ260008",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 692,
          "timestamp": "13-MAR-2026 12:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "13-MAR-2026 12:45:50",
          "sampleID": "D/IM/26/03/1149",
          "sampleDescription": "DIMCBSQ260008",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.21 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 693,
          "timestamp": "13-MAR-2026 12:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "13-MAR-2026 12:45:50",
          "sampleID": "D/IM/26/03/1149",
          "sampleDescription": "DIMCBSQ260008",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "97.7",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 694,
          "timestamp": "13-MAR-2026 12:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "13-MAR-2026 12:45:50",
          "sampleID": "D/IM/26/03/1149",
          "sampleDescription": "DIMCBSQ260008",
          "specificationLimit": "Report the result",
          "resultValue": "94.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 695,
          "timestamp": "13-MAR-2026 12:45:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "13-MAR-2026 12:45:50",
          "sampleID": "D/IM/26/03/1149",
          "sampleDescription": "DIMCBSQ260008",
          "specificationLimit": "Report the result",
          "resultValue": "94.5 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26009",
      "messages": [
        {
          "id": 342,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26001",
          "targetQuantity": "28.5 Kg",
          "actualQuantity": "28.5 Kg"
        },
        {
          "id": 343,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 344,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 345,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 346,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "26.43637 Lt.",
          "actualQuantity": "26.43637 Lt."
        },
        {
          "id": 347,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26002",
          "targetQuantity": "3.56363 Lt.",
          "actualQuantity": "3.56363 Lt."
        },
        {
          "id": 348,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "387 Lt.",
          "actualQuantity": "387 Lt."
        },
        {
          "id": 349,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "66 Lt.",
          "actualQuantity": "66 Lt."
        },
        {
          "id": 350,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 351,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "600 Lt.",
          "actualQuantity": "600 Lt."
        },
        {
          "id": 352,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "231 Lt.",
          "actualQuantity": "231 Lt."
        },
        {
          "id": 353,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "660 Lt.",
          "actualQuantity": "660 Lt."
        },
        {
          "id": 354,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "29 Lt.",
          "actualQuantity": "29 Lt."
        },
        {
          "id": 355,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "149 Lt.",
          "actualQuantity": "149 Lt."
        },
        {
          "id": 356,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "909.2649 Lt.",
          "actualQuantity": "909.2649 Lt."
        },
        {
          "id": 357,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 358,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 359,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "660 Lt.",
          "actualQuantity": "660 Lt."
        },
        {
          "id": 360,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "422 Lt.",
          "actualQuantity": "422 Lt."
        },
        {
          "id": 361,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "560 Lt.",
          "actualQuantity": "560 Lt."
        },
        {
          "id": 362,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "12.73509 Lt.",
          "actualQuantity": "12.73509 Lt."
        },
        {
          "id": 363,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 364,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 365,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030726",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 366,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030726",
          "targetQuantity": "35 Lt.",
          "actualQuantity": "35 Lt."
        },
        {
          "id": 367,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01030626",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 368,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "76.12 Kg",
          "actualQuantity": "76.12 Kg"
        },
        {
          "id": 369,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 370,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "4 Kg",
          "actualQuantity": "4 Kg"
        },
        {
          "id": 371,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26016",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 372,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25006",
          "targetQuantity": "99.765 Kg",
          "actualQuantity": "99.765 Kg"
        },
        {
          "id": 373,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25007",
          "targetQuantity": "120.235 Kg",
          "actualQuantity": "120.235 Kg"
        },
        {
          "id": 374,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26017",
          "targetQuantity": "6 Each",
          "actualQuantity": "6 Each"
        },
        {
          "id": 375,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 602,
          "timestamp": "06-MAR-2026 16:11:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "06-MAR-2026 16:11:50",
          "sampleID": "D/IM/26/03/0599",
          "sampleDescription": "DIP26030583",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 603,
          "timestamp": "06-MAR-2026 16:19:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "06-MAR-2026 16:19:49",
          "sampleID": "D/IM/26/03/0600",
          "sampleDescription": "DIP26030585",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 608,
          "timestamp": "08-MAR-2026 00:56:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "08-MAR-2026 00:56:50",
          "sampleID": "D/IM/26/03/0659",
          "sampleDescription": "DIP26030681",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 609,
          "timestamp": "08-MAR-2026 00:56:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "08-MAR-2026 00:56:50",
          "sampleID": "D/IM/26/03/0659",
          "sampleDescription": "DIP26030681",
          "specificationLimit": "Report the result",
          "resultValue": "0.767",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 610,
          "timestamp": "08-MAR-2026 17:53:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "08-MAR-2026 17:53:49",
          "sampleID": "D/IM/26/03/0774",
          "sampleDescription": "DIP26030754",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 620,
          "timestamp": "14-MAR-2026 08:21:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "14-MAR-2026 08:21:50",
          "sampleID": "D/IM/26/03/1185",
          "sampleDescription": "DIP26031211",
          "specificationLimit": "Report the result",
          "resultValue": "0.976",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 621,
          "timestamp": "14-MAR-2026 08:21:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "14-MAR-2026 08:21:50",
          "sampleID": "D/IM/26/03/1185",
          "sampleDescription": "DIP26031211",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 622,
          "timestamp": "14-MAR-2026 08:21:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "14-MAR-2026 08:21:50",
          "sampleID": "D/IM/26/03/1185",
          "sampleDescription": "DIP26031211",
          "specificationLimit": "Report the result",
          "resultValue": "0.0009",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 627,
          "timestamp": "16-MAR-2026 03:19:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "16-MAR-2026 03:19:50",
          "sampleID": "D/IM/26/03/1421",
          "sampleDescription": "DIP26031365",
          "specificationLimit": "Report the result",
          "resultValue": "0.49 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 696,
          "timestamp": "17-MAR-2026 19:52:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "17-MAR-2026 19:52:50",
          "sampleID": "D/IM/26/03/1577",
          "sampleDescription": "DIMCBSQ260009",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 697,
          "timestamp": "17-MAR-2026 19:52:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "17-MAR-2026 19:52:50",
          "sampleID": "D/IM/26/03/1577",
          "sampleDescription": "DIMCBSQ260009",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 698,
          "timestamp": "17-MAR-2026 19:52:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "17-MAR-2026 19:52:50",
          "sampleID": "D/IM/26/03/1577",
          "sampleDescription": "DIMCBSQ260009",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.65 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 699,
          "timestamp": "17-MAR-2026 19:52:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "17-MAR-2026 19:52:50",
          "sampleID": "D/IM/26/03/1577",
          "sampleDescription": "DIMCBSQ260009",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.98",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 700,
          "timestamp": "17-MAR-2026 19:52:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "17-MAR-2026 19:52:50",
          "sampleID": "D/IM/26/03/1577",
          "sampleDescription": "DIMCBSQ260009",
          "specificationLimit": "Report the result",
          "resultValue": "95.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 701,
          "timestamp": "17-MAR-2026 19:52:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "17-MAR-2026 19:52:50",
          "sampleID": "D/IM/26/03/1577",
          "sampleDescription": "DIMCBSQ260009",
          "specificationLimit": "Report the result",
          "resultValue": "95.8 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26010",
      "messages": [
        {
          "id": 376,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "10 Each",
          "actualQuantity": "10 Each"
        },
        {
          "id": 377,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26005",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 378,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 379,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25007",
          "targetQuantity": "185.495 Kg",
          "actualQuantity": "185.495 Kg"
        },
        {
          "id": 380,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25008",
          "targetQuantity": "194.505 Kg",
          "actualQuantity": "194.505 Kg"
        },
        {
          "id": 381,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26017",
          "targetQuantity": "10 Each",
          "actualQuantity": "10 Each"
        },
        {
          "id": 382,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26018",
          "targetQuantity": "10 Each",
          "actualQuantity": "10 Each"
        },
        {
          "id": 383,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26018",
          "targetQuantity": "10 Each",
          "actualQuantity": "10 Each"
        },
        {
          "id": 384,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26019",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 385,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "10 Kg",
          "actualQuantity": "10 Kg"
        },
        {
          "id": 386,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "131.48 Kg",
          "actualQuantity": "131.48 Kg"
        },
        {
          "id": 387,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-26001",
          "targetQuantity": "18.62 Kg",
          "actualQuantity": "0 Kg"
        },
        {
          "id": 388,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 389,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 390,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 391,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 392,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "11.1046 Lt.",
          "actualQuantity": "11.1046 Lt."
        },
        {
          "id": 393,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-25008",
          "targetQuantity": "3.89539 Lt.",
          "actualQuantity": "3.89539 Lt."
        },
        {
          "id": 394,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "26.891 Lt.",
          "actualQuantity": "26.891 Lt."
        },
        {
          "id": 395,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "13.109 Lt.",
          "actualQuantity": "13.109 Lt."
        },
        {
          "id": 396,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "2571 Lt.",
          "actualQuantity": "2571 Lt."
        },
        {
          "id": 397,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "897.31812 Lt.",
          "actualQuantity": "897.31812 Lt."
        },
        {
          "id": 398,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "114 Lt.",
          "actualQuantity": "114 Lt."
        },
        {
          "id": 399,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 400,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "285 Lt.",
          "actualQuantity": "285 Lt."
        },
        {
          "id": 401,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "285 Lt.",
          "actualQuantity": "285 Lt."
        },
        {
          "id": 402,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 403,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-15",
          "targetQuantity": "331.68187 Lt.",
          "actualQuantity": "331.68187 Lt."
        },
        {
          "id": 404,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-14",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 405,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "285 Lt.",
          "actualQuantity": "285 Lt."
        },
        {
          "id": 406,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "285 Lt.",
          "actualQuantity": "285 Lt."
        },
        {
          "id": 407,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 408,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "1900 Lt.",
          "actualQuantity": "1900 Lt."
        },
        {
          "id": 409,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "570 Lt.",
          "actualQuantity": "570 Lt."
        },
        {
          "id": 410,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "570 Lt.",
          "actualQuantity": "570 Lt."
        },
        {
          "id": 411,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031126",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 412,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031126",
          "targetQuantity": "60 Lt.",
          "actualQuantity": "60 Lt."
        },
        {
          "id": 413,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031026",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 614,
          "timestamp": "10-MAR-2026 01:59:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "10-MAR-2026 01:59:50",
          "sampleID": "D/IM/26/03/0903",
          "sampleDescription": "DIP26030870",
          "specificationLimit": "Report the result",
          "resultValue": "0.06 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 616,
          "timestamp": "12-MAR-2026 02:16:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "12-MAR-2026 02:16:49",
          "sampleID": "D/IM/26/03/1001",
          "sampleDescription": "DIP26031033",
          "specificationLimit": "Report the result",
          "resultValue": "0.0017",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 617,
          "timestamp": "12-MAR-2026 02:16:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "12-MAR-2026 02:16:49",
          "sampleID": "D/IM/26/03/1001",
          "sampleDescription": "DIP26031033",
          "specificationLimit": "Report the result",
          "resultValue": "0.62",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 625,
          "timestamp": "15-MAR-2026 02:44:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "15-MAR-2026 02:44:50",
          "sampleID": "D/IM/26/03/1327",
          "sampleDescription": "DIP26031280",
          "specificationLimit": "Report the result",
          "resultValue": "0.04 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 626,
          "timestamp": "15-MAR-2026 16:51:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "15-MAR-2026 16:51:50",
          "sampleID": "D/IM/26/03/1381",
          "sampleDescription": "DIP26031330",
          "specificationLimit": "Report the result",
          "resultValue": "0.07 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 629,
          "timestamp": "17-MAR-2026 09:52:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "17-MAR-2026 09:52:50",
          "sampleID": "D/IM/26/03/1428",
          "sampleDescription": "DIP26031507",
          "specificationLimit": "Report the result",
          "resultValue": "0.981",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 630,
          "timestamp": "17-MAR-2026 09:52:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "17-MAR-2026 09:52:50",
          "sampleID": "D/IM/26/03/1428",
          "sampleDescription": "DIP26031507",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 631,
          "timestamp": "17-MAR-2026 09:52:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "17-MAR-2026 09:52:50",
          "sampleID": "D/IM/26/03/1428",
          "sampleDescription": "DIP26031507",
          "specificationLimit": "Report the result",
          "resultValue": "Not Detected",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 635,
          "timestamp": "19-MAR-2026 06:26:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "19-MAR-2026 06:26:50",
          "sampleID": "D/IM/26/03/1739",
          "sampleDescription": "DIP26031696",
          "specificationLimit": "Report the result",
          "resultValue": "0.51 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 702,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 703,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 704,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "2.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 705,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.985",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 706,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "Report the result",
          "resultValue": "91.8 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 707,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "Report the result",
          "resultValue": "94.0 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 708,
          "timestamp": "21-MAR-2026 10:07:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Use test",
          "dateOfSampling": "21-MAR-2026 10:07:50",
          "sampleID": "D/IM/26/03/1875",
          "sampleDescription": "DIMCBSQ260010",
          "specificationLimit": "Report the result",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        }
      ]
    },
    {
      "batchNumber": "DBSQC26011",
      "messages": [
        {
          "id": 414,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "330 Lt.",
          "actualQuantity": "330 Lt."
        },
        {
          "id": 415,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 416,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "330 Lt.",
          "actualQuantity": "330 Lt."
        },
        {
          "id": 417,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "112.73509 Lt.",
          "actualQuantity": "112.73509 Lt."
        },
        {
          "id": 418,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "1548.2649 Lt.",
          "actualQuantity": "1548.2649 Lt."
        },
        {
          "id": 419,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 420,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "66 Lt.",
          "actualQuantity": "66 Lt."
        },
        {
          "id": 421,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "70.2649 Lt.",
          "actualQuantity": "70.2649 Lt."
        },
        {
          "id": 422,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 423,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 424,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "397 Lt.",
          "actualQuantity": "397 Lt."
        },
        {
          "id": 425,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "150.2649 Lt.",
          "actualQuantity": "150.2649 Lt."
        },
        {
          "id": 426,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 427,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "929.73509 Lt.",
          "actualQuantity": "929.73509 Lt."
        },
        {
          "id": 428,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 429,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "86.73509 Lt.",
          "actualQuantity": "86.73509 Lt."
        },
        {
          "id": 430,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-16",
          "targetQuantity": "565 Lt.",
          "actualQuantity": "565 Lt."
        },
        {
          "id": 431,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01031326",
          "targetQuantity": "35 Lt.",
          "actualQuantity": "35 Lt."
        },
        {
          "id": 432,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01031326",
          "targetQuantity": "400 Lt.",
          "actualQuantity": "400 Lt."
        },
        {
          "id": 433,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01031326",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 434,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 435,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 436,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "5.36373 Lt.",
          "actualQuantity": "5.36373 Lt."
        },
        {
          "id": 437,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "14.63626 Lt.",
          "actualQuantity": "14.63626 Lt."
        },
        {
          "id": 438,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032626",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 439,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032026",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 440,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032026",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 441,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032726",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 442,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032326",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 443,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032326",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 444,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032426",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 445,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032226",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 446,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032226",
          "targetQuantity": "300 Lt.",
          "actualQuantity": "300 Lt."
        },
        {
          "id": 447,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032226",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 448,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG01032626",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 449,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 450,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 451,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "2.59081 Lt.",
          "actualQuantity": "2.59081 Lt."
        },
        {
          "id": 452,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "139.90919 Lt.",
          "actualQuantity": "139.90919 Lt."
        },
        {
          "id": 453,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 454,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "157.5 Lt.",
          "actualQuantity": "157.5 Lt."
        },
        {
          "id": 455,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 456,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26001",
          "targetQuantity": "19 Kg",
          "actualQuantity": "19 Kg"
        },
        {
          "id": 457,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 458,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "13.29 Kg",
          "actualQuantity": "13.29 Kg"
        },
        {
          "id": 459,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-26001",
          "targetQuantity": "62.83 Kg",
          "actualQuantity": "62.83 Kg"
        },
        {
          "id": 460,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26004",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 461,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26005",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 462,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26005",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 463,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26020",
          "targetQuantity": "8 Each",
          "actualQuantity": "8 Each"
        },
        {
          "id": 464,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26018",
          "targetQuantity": "6 Each",
          "actualQuantity": "6 Each"
        },
        {
          "id": 465,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25008",
          "targetQuantity": "117.125 Kg",
          "actualQuantity": "117.125 Kg"
        },
        {
          "id": 466,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25009",
          "targetQuantity": "102.875 Kg",
          "actualQuantity": "102.875 Kg"
        },
        {
          "id": 467,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 468,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26003",
          "targetQuantity": "3 Kg",
          "actualQuantity": "3 Kg"
        },
        {
          "id": 618,
          "timestamp": "13-MAR-2026 08:41:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "13-MAR-2026 08:41:50",
          "sampleID": "D/IM/26/03/1190",
          "sampleDescription": "DIP26031148",
          "specificationLimit": "Report the result",
          "resultValue": "0.04 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 619,
          "timestamp": "13-MAR-2026 08:43:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "13-MAR-2026 08:43:50",
          "sampleID": "D/IM/26/03/1191",
          "sampleDescription": "DIP26031149",
          "specificationLimit": "Report the result",
          "resultValue": "0.05 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 623,
          "timestamp": "14-MAR-2026 17:24:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "14-MAR-2026 17:24:50",
          "sampleID": "D/IM/26/03/1240",
          "sampleDescription": "DIP26031233",
          "specificationLimit": "Report the result",
          "resultValue": "0.002",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 624,
          "timestamp": "14-MAR-2026 17:24:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "14-MAR-2026 17:24:50",
          "sampleID": "D/IM/26/03/1240",
          "sampleDescription": "DIP26031233",
          "specificationLimit": "Report the result",
          "resultValue": "0.772",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 632,
          "timestamp": "18-MAR-2026 07:50:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "18-MAR-2026 07:50:49",
          "sampleID": "D/IM/26/03/1647",
          "sampleDescription": "DIP26031607",
          "specificationLimit": "Report the result",
          "resultValue": "0.04 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 636,
          "timestamp": "20-MAR-2026 21:51:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "20-MAR-2026 21:51:50",
          "sampleID": "D/IM/26/03/1747",
          "sampleDescription": "DIP26031826",
          "specificationLimit": "Report the result",
          "resultValue": "0.981",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 637,
          "timestamp": "20-MAR-2026 21:51:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "20-MAR-2026 21:51:50",
          "sampleID": "D/IM/26/03/1747",
          "sampleDescription": "DIP26031826",
          "specificationLimit": "Report the result",
          "resultValue": "0.0006",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 638,
          "timestamp": "20-MAR-2026 21:51:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "20-MAR-2026 21:51:50",
          "sampleID": "D/IM/26/03/1747",
          "sampleDescription": "DIP26031826",
          "specificationLimit": "Report the result",
          "resultValue": "0.0009",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 641,
          "timestamp": "23-MAR-2026 08:56:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "23-MAR-2026 08:56:50",
          "sampleID": "D/IM/26/03/2039",
          "sampleDescription": "DIP26032081",
          "specificationLimit": "Report the result",
          "resultValue": "0.48 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 709,
          "timestamp": "24-MAR-2026 15:02:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Description",
          "dateOfSampling": "24-MAR-2026 15:02:50",
          "sampleID": "D/IM/26/03/2235",
          "sampleDescription": "DIMCBSQ260011",
          "specificationLimit": "Report the observation",
          "resultValue": "Pale yellow color solid ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 710,
          "timestamp": "24-MAR-2026 15:02:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Identification by UPLC",
          "dateOfSampling": "24-MAR-2026 15:02:50",
          "sampleID": "D/IM/26/03/2235",
          "sampleDescription": "DIMCBSQ260011",
          "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
          "resultValue": "Complies ",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 711,
          "timestamp": "24-MAR-2026 15:02:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Loss on drying (% w/w)",
          "dateOfSampling": "24-MAR-2026 15:02:50",
          "sampleID": "D/IM/26/03/2235",
          "sampleDescription": "DIMCBSQ260011",
          "specificationLimit": "Not more than 2.0",
          "resultValue": "0.23 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 712,
          "timestamp": "24-MAR-2026 15:02:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Chromatographic purity by UPLC (% area)",
          "dateOfSampling": "24-MAR-2026 15:02:50",
          "sampleID": "D/IM/26/03/2235",
          "sampleDescription": "DIMCBSQ260011",
          "specificationLimit": "Not less than 90.0",
          "resultValue": "0.975",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        },
        {
          "id": 713,
          "timestamp": "24-MAR-2026 15:02:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w, as is basis)",
          "dateOfSampling": "24-MAR-2026 15:02:50",
          "sampleID": "D/IM/26/03/2235",
          "sampleDescription": "DIMCBSQ260011",
          "specificationLimit": "Report the result",
          "resultValue": "95.1 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        },
        {
          "id": 714,
          "timestamp": "24-MAR-2026 15:02:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "Assay by UPLC (% w/w)(on dried basis)",
          "dateOfSampling": "24-MAR-2026 15:02:50",
          "sampleID": "D/IM/26/03/2235",
          "sampleDescription": "DIMCBSQ260011",
          "specificationLimit": "Report the result",
          "resultValue": "95.3 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Complete analysis/123",
          "uom": "% w/w"
        }
      ]
    },
    {
      "batchNumber": "DBSQC26012",
      "messages": [
        {
          "id": 469,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26005",
          "targetQuantity": "5 Kg",
          "actualQuantity": "5 Kg"
        },
        {
          "id": 470,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26005",
          "targetQuantity": "10 Kg",
          "actualQuantity": "10 Kg"
        },
        {
          "id": 471,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\"",
          "cmoMaterialCode": "PPLBA00117",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00117-26005",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 472,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”)",
          "cmoMaterialCode": "PPLBA00050",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPPLBA00050-26003",
          "targetQuantity": "2 Kg",
          "actualQuantity": "2 Kg"
        },
        {
          "id": 473,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B)",
          "cmoMaterialCode": "INTBSQB001",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DBSQB25009",
          "targetQuantity": "205 Kg",
          "actualQuantity": "205 Kg"
        },
        {
          "id": 474,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26019",
          "targetQuantity": "20 Each",
          "actualQuantity": "20 Each"
        },
        {
          "id": 475,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap.",
          "cmoMaterialCode": "PCNCT00034",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DPCNCT00034-26022",
          "targetQuantity": "6 Each",
          "actualQuantity": "6 Each"
        },
        {
          "id": 476,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-25001",
          "targetQuantity": "17.64 Kg",
          "actualQuantity": "17.64 Kg"
        },
        {
          "id": 477,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4]",
          "cmoMaterialCode": "RCHCG00432",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00432-26001",
          "targetQuantity": "53.29 Kg",
          "actualQuantity": "53.29 Kg"
        },
        {
          "id": 478,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032626",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 479,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 480,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "61 Lt.",
          "actualQuantity": "61 Lt."
        },
        {
          "id": 481,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "615 Lt.",
          "actualQuantity": "615 Lt."
        },
        {
          "id": 482,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "992.08239 Lt.",
          "actualQuantity": "992.08239 Lt."
        },
        {
          "id": 483,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 484,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "302.9176 Lt.",
          "actualQuantity": "302.9176 Lt."
        },
        {
          "id": 485,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-19",
          "targetQuantity": "5.08239 Lt.",
          "actualQuantity": "5.08239 Lt."
        },
        {
          "id": 486,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-19",
          "targetQuantity": "307 Lt.",
          "actualQuantity": "307 Lt."
        },
        {
          "id": 487,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "466.41318 Lt.",
          "actualQuantity": "466.41318 Lt."
        },
        {
          "id": 488,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "30 Lt.",
          "actualQuantity": "30 Lt."
        },
        {
          "id": 489,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "169.83523 Lt.",
          "actualQuantity": "169.83523 Lt."
        },
        {
          "id": 490,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "965.08239 Lt.",
          "actualQuantity": "965.08239 Lt."
        },
        {
          "id": 491,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "32.9176 Lt.",
          "actualQuantity": "32.9176 Lt."
        },
        {
          "id": 492,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-18",
          "targetQuantity": "80 Lt.",
          "actualQuantity": "80 Lt."
        },
        {
          "id": 493,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL   [2-PROPANOL]  (COM)  [67-63-0]",
          "cmoMaterialCode": "RSLCG00016",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "PDRSLCG00016-25011-17",
          "targetQuantity": "448.6692 Lt.",
          "actualQuantity": "448.6692 Lt."
        },
        {
          "id": 494,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031626",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 495,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031726",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 496,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031726",
          "targetQuantity": "32 Lt.",
          "actualQuantity": "32 Lt."
        },
        {
          "id": 497,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26003",
          "targetQuantity": "47.5 Kg",
          "actualQuantity": "47.5 Kg"
        },
        {
          "id": 498,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26003",
          "targetQuantity": "47.5 Kg",
          "actualQuantity": "47.5 Kg"
        },
        {
          "id": 499,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE  (COM)  [68-12-2]",
          "cmoMaterialCode": "RSLCG00010",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRSLCG00010-26004",
          "targetQuantity": "19 Kg",
          "actualQuantity": "19 Kg"
        },
        {
          "id": 500,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031726",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 501,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031726",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 502,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02031826",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 503,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032526",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 504,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032426",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 505,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032426",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 506,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 507,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 508,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "20 Lt.",
          "actualQuantity": "20 Lt."
        },
        {
          "id": 509,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26003",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 510,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 511,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "40 Lt.",
          "actualQuantity": "40 Lt."
        },
        {
          "id": 512,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "70 Lt.",
          "actualQuantity": "70 Lt."
        },
        {
          "id": 513,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "500 Lt.",
          "actualQuantity": "500 Lt."
        },
        {
          "id": 514,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE  (COM)  [67-68-5]",
          "cmoMaterialCode": "RCHCG00368",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DRCHCG00368-26005",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 515,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032426",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 516,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032426",
          "targetQuantity": "10 Lt.",
          "actualQuantity": "10 Lt."
        },
        {
          "id": 517,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032426",
          "targetQuantity": "200 Lt.",
          "actualQuantity": "200 Lt."
        },
        {
          "id": 518,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032526",
          "targetQuantity": "50 Lt.",
          "actualQuantity": "50 Lt."
        },
        {
          "id": 519,
          "timestamp": "07-APR-2026 06:34:03",
          "messageType": "Material",
          "procedureNumber": "",
          "cmoMaterialDescription": "DI Water",
          "cmoMaterialCode": "DI",
          "sponsorMaterialCode": "",
          "cmoMaterialBatchNumber": "DDWG02032626",
          "targetQuantity": "100 Lt.",
          "actualQuantity": "100 Lt."
        },
        {
          "id": 628,
          "timestamp": "17-MAR-2026 00:59:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "17-MAR-2026 00:59:50",
          "sampleID": "D/IM/26/03/1508",
          "sampleDescription": "DIP26031460",
          "specificationLimit": "Report the result",
          "resultValue": "0.08 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 633,
          "timestamp": "18-MAR-2026 12:08:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-B",
          "dateOfSampling": "18-MAR-2026 12:08:49",
          "sampleID": "D/IM/26/03/1532",
          "sampleDescription": "DIP26031631",
          "specificationLimit": "Report the result",
          "resultValue": "0",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 634,
          "timestamp": "18-MAR-2026 12:08:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity of Stage-C.",
          "dateOfSampling": "18-MAR-2026 12:08:49",
          "sampleID": "D/IM/26/03/1532",
          "sampleDescription": "DIP26031631",
          "specificationLimit": "Report the result",
          "resultValue": "0.773",
          "resultPassFail": "Pass",
          "operationNumber": "Reaction monitoring of Stage-C by UPLC (BSQ-IP-03 test, 02)/22",
          "uom": "%"
        },
        {
          "id": 640,
          "timestamp": "22-MAR-2026 18:46:49",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
          "dateOfSampling": "22-MAR-2026 18:46:49",
          "sampleID": "D/IM/26/03/2040",
          "sampleDescription": "DIP26032009",
          "specificationLimit": "Report the result",
          "resultValue": "0.07 % w/v",
          "resultPassFail": "Pass",
          "operationNumber": "Water content of Isopropyl alcohol by KF (BSQ-IP-03 test, 01)/01",
          "uom": "% w/v"
        },
        {
          "id": 642,
          "timestamp": "24-MAR-2026 00:10:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Purity",
          "dateOfSampling": "24-MAR-2026 00:10:50",
          "sampleID": "D/IM/26/03/1942",
          "sampleDescription": "DIP26032141",
          "specificationLimit": "Report the result",
          "resultValue": "0.977",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 643,
          "timestamp": "24-MAR-2026 00:10:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of benzophenone hydrazine",
          "dateOfSampling": "24-MAR-2026 00:10:50",
          "sampleID": "D/IM/26/03/1942",
          "sampleDescription": "DIP26032141",
          "specificationLimit": "Report the result",
          "resultValue": "0.0006",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 644,
          "timestamp": "24-MAR-2026 00:10:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Content of Stage-C dimer impurity",
          "dateOfSampling": "24-MAR-2026 00:10:50",
          "sampleID": "D/IM/26/03/1942",
          "sampleDescription": "DIP26032141",
          "specificationLimit": "Report the result",
          "resultValue": "0.0009",
          "resultPassFail": "Pass",
          "operationNumber": "Chromatographic purity of Stage-C by UPLC (BSQ-IP-03 test, 03)/61",
          "uom": "%"
        },
        {
          "id": 645,
          "timestamp": "25-MAR-2026 21:02:50",
          "messageType": "In-Process Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IP-03/00",
          "methodName": "Loss on drying of Stage-C (% w/w)",
          "dateOfSampling": "25-MAR-2026 21:02:50",
          "sampleID": "D/IM/26/03/2378",
          "sampleDescription": "DIP26032361",
          "specificationLimit": "Report the result",
          "resultValue": "0.58 % w/w",
          "resultPassFail": "Pass",
          "operationNumber": "Loss on drying of Stage-C (BSQ-IP-03 test, 04)/84",
          "uom": "% w/w"
        },
        {
          "id": 715,
          "timestamp": "27-MAR-2026 04:58:50",
          "messageType": "Information Testing",
          "procedureNumber": "",
          "outletNumber": "",
          "methodNumber": "BSQ-IN-03/00",
          "methodName": "",
          "dateOfSampling": "27-MAR-2026 04:58:50",
          "sampleID": "D/IM/26/03/2467",
          "sampleDescription": "DIMCBSQ260012",
          "specificationLimit": "",
          "resultValue": "",
          "resultPassFail": "N/A",
          "operationNumber": "Complete analysis/123",
          "uom": ""
        }
      ]
    }
  ]
};
